/**
 * Configuration Service - Static Maps
 * Extracted from configService.ts for cleaner separation
 */

/** Map backend workflow/entity type → display type label */
export const ENTITY_TYPE_MAP: Record<string, string> = {
	INDIVIDUAL: 'Individual',
	NAMEDINDIVIDUAL: 'Named Individual',
	SOLETRADER: 'Sole Trader',
	BUSINESSENTITY_PRINCIPALS_UBOEXEMPT: 'Company',
	BUSINESSENTITY_PRINCIPALS: 'Company',
	BUSINESSENTITY_PRINCIPALS_NEEDSUBO: 'Company',
	BUSINESSENTITY_NOPRINCIPALS_NEEDSUBO: 'Company',
	BUSINESSENTITY_NOPRINCIPALS_UBOEXEMPT: 'Company',
	TRUST: 'Trust',
	ASSOCIATION: 'Association',
	VEHICLE: 'Trust',        // VEHICLE = trust / partnership / fund internal code
	NON_ASIC_ENTITY: 'Organisation',
	ASIC_ENTITY: 'Company',
};
